import { render, staticRenderFns } from "./NamedRateForm.vue?vue&type=template&id=4cf6828c&"
import script from "./NamedRateForm.vue?vue&type=script&lang=js&"
export * from "./NamedRateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports